import { render, staticRenderFns } from "./akl.vue?vue&type=template&id=ad9d1234&"
import script from "./akl.vue?vue&type=script&lang=js&"
export * from "./akl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports